<template>
  <div>
    <van-field size="large" name="uploader" label="上传图片">
      <template #input>
        <van-uploader v-model="uploader">
          <div></div>
        </van-uploader>
        <div v-if="uploader.length < count" class="van-uploader__upload" @click="chooseImage">
          <van-icon color="#dcdee0" style="font-size: 24px;" name="photograph"></van-icon>
        </div>
      </template>
    </van-field>
  </div>
</template>
<script>
import { uploaderfiles } from '@/api/base';
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      uploader: this.value,
      count: 9,
    };
  },
  methods: {
    chooseImage() {
      let that = this;
      let count = Number(this.count) - Number(this.uploader.length);
      wx.chooseImage({
        count: count, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function(res) {
          that.syncUpload(res.localIds, 0);
        },
      });
    },
    async syncUpload(localIds, num) {
      this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
      });
      let that = this;
      let id = String(localIds[num]);
      if (id.indexOf('wxlocalresource') != -1) {
        id = id.replace('wxlocalresource', 'wxLocalResource');
      }
      await wx.uploadImage({
        localId: id, // 需要上传的图片的本地ID，由chooseImage接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function(res) {
          // that.list.push(res.serverId);
          if (Number(num) < localIds.length) {
            // setTimeout(function() {
            // that.syncUpload(localIds, Number(num) + 1);
            that.uploaderfilefun(res.serverId, localIds, Number(num) + 1);
            // }, 1000);
          }
          // else {
          //   let str = '';
          //   that.list.map(item => {
          //     str += 'mediaIds=' + item + '&';
          //   });
          //   uploaderfile(str).then(res => {
          //     console.log(res);
          //     // that.listimg = res.data;
          //     let listarr = [];
          //     res.data.map(item => {
          //       listarr.push({ url: item });
          //     });
          //     that.uploader = listarr;
          //     that.$emit('input', listarr);
          //   });
          // }
        },
        fail: function(e) {
          // that.failtext = e;
          // that.syncUpload(localIds, num);
        },
      });
    },
    async uploaderfilefun(serverId, localId, num) {
      console.log(num);
      let that = this;
      let str = 'mediaIds=' + serverId;
      await uploaderfiles(str).then(res => {
        that.uploader.push({ url: res.data[0] + '?x-oss-process=image/resize,l_1400'});
        that.$emit('input', that.uploader);
        if (Number(num) < serverId.length) {
          that.syncUpload(localId, num);
        } else {
          this.$toast.clear();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.uploader_box {
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  .van-uploader {
    position: relative;
    display: inline-block;
    .van-uploader_wrapper {
      display: flex;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      .van-uploader__upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 70px;
        height: 80px;
        margin: 0 8px 8px 0;
        background-color: #f7f8fa;
        .uploader__input {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          cursor: pointer;
          opacity: 0;
        }
      }
      .van-uploader__preview {
        position: relative;
        margin: 0 8px 8px 0;
        cursor: pointer;
        .van-uploader__preview-image {
          display: block;
          width: 80px;
          height: 80px;
          overflow: hidden;
          position: relative;
          .van-image__img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .van-uploader__preview-delete {
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
          background-color: rgba(0, 0, 0, 0.7);
          border-radius: 0 0 0 12px;
          .van-uploader__preview-delete-icon {
            position: absolute;
            top: -2px;
            right: -2px;
            color: #fff;
            font-size: 16px;
            -webkit-transform: scale(0.5);
            transform: scale(0.5);
          }
        }
      }
      .van-uploader__mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: rgba(50, 50, 51, 0.88);
        .van-uploader__loading {
          width: 22px;
          height: 22px;
          color: #fff;
          position: relative;
          vertical-align: middle;
          .van-loading__spinner {
            position: relative;
            display: inline-block;
            width: 30px;
            max-width: 100%;
            height: 30px;
            max-height: 100%;
            vertical-align: middle;
            animation: van-rotate 0.8s linear infinite;
            .van-loading__circular {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .van-loading__spinner--circular {
            animation-duration: 2s;
          }
        }
        .van-uploader__mask-message {
          margin-top: 6px;
          padding: 0 4px;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }
}
</style>
